const SocketMessages = {
	QR_CODE_ACTIVATED: "QR_CODE_ACTIVATED"
};
export default SocketMessages;
